<template>
  <div class="container text-center container_bg">
    <h2 class="pt-6">保函样张确认</h2>
    <Step :arr="arr"
          class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <pdf :url="pdfUrl" title="投标保函"></pdf>
    </div>
    <el-button type="primary"
               class="mt-3 mb-3"
               @click="goLetter"
               v-if="types"
               :loading="loading">已确认，去{{ types }}</el-button>
  </div>
</template>
<script>
import Step from '../../components/CA/Step'
import pdf from '../../components/pdf/pdf'
import {
  checkCommitment,
  commitmentSign,
  queryModePayment,
} from '../../../src/api/comm'
import { pay } from '@/shared/pay'
import { isIe } from '@/util/util'

export default {
  name: 'letterCmmmit.vue',
  data() {
    return {
      pdfUrl: '',
      guaranteeTitle: '',
      types: '',
      arr: [
        { icon: 1, span: '保函样张确认', status: 'finish', time: '' },
        { icon: 2, span: '承诺书签订', status: 'wa', time: '' },
      ],
      loading: false,
      query: {}, // fixed ie bug
      paymentType:'',
    }
  },

  components: {
    Step,
    pdf,
  },
  created() {
    this.query = this.$route.query
    this.pdfUrl = '/zcjf/base/file/download/' + this.$route.query.pdfID
    const { orderId } =  this.query
    queryModePayment({
      orderId: orderId,
    }).then((res) => {
      this.paymentType = res.data
      this.checkCommitment()
    })
  },
  methods: {
    checkCommitment() {
      //判断是否需要签订承诺书  目前2中判断条件  1、bfe_docking_platform配置表配置了取配置表内容，否则调用接口判断 无需签订承诺书
      const { province, district, city, isNeedCommitment } = this.query
      if (isNeedCommitment != undefined) {
        if (isNeedCommitment === true) {
          this.types = '签订承诺书'
        } else {
          this.types = this.getPayName()
          this.arr.splice(1)
        }
      } else {
        const { orderId } = this.query
        return checkCommitment({
          orderId
        }).then((res) => {
          if (res.data) {
            this.types = '签订承诺书'
          } else {
            this.types = this.getPayName()
            this.arr.splice(1)
          }
          return true
        })
      }
    },
    getPayName(){
      return this.paymentType === '1'?'上传电汇底单':'支付'
    },
    goLetter() {
      const { types } = this
      const { orderId } = this.query
      if (types === '签订承诺书') {
        this.loading = true
        commitmentSign({
          orderId: orderId,
        }).then((res) => {
          this.loading = false
          const ie = isIe()
          const router = {
            name: 'letterCmmmitOk',
            query: {
              id: res.data,
              orderId: orderId,
            },
          }
          if (ie) {
            const { href } = this.$router.resolve(router)
            const location = window.location.origin + '/' + href
            console.log('ie-open', href, location)
            window.open(location)
          } else {
            this.$router.push(router)
          }
        })
      } else {
        if (this.paymentType && this.paymentType === '1') {
            // 线下支付
            this.$router.push({
              path: '/wire-transfer',
              query: {
                order: orderId,
              },
            })
          } else {
            pay.call(this, orderId)
          }
      }
    },
  },
}
</script>
